import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { uploadFiles, startFilesProcess, endFilesProcess } from '../actions/files';
import { getBase64FromFiles } from '../services/file-service';
import { checkStorageLimit } from '../utils/file-upload';

export default class FileUpload extends PureComponent {
    static propTypes = {
        projectId: PropTypes.string,
        taskId: PropTypes.string,
        docId: PropTypes.string,
        single: PropTypes.bool,
        upload: PropTypes.bool,
        withBase64: PropTypes.bool,
        preventLimitCheck: PropTypes.bool,
        provideController: PropTypes.func,
        onChange: PropTypes.func,
        onUpload: PropTypes.func
    };

    static defaultProps = {
        showProcessing: true
    };

    handleChange = async event => {
        const files = this.getSelectedFiles(event);
        this.showProcessingAlert(files);
        await this.processFiles(files);
        this.hideProcessingAlert(files);

        if (this.fileElement) {
            this.fileElement.value = '';
        }
    };

    async processFiles(files) {
        try {
            await this.checkLimit(files);

            if (this.props.onChange) {
                if (this.props.withBase64) {
                    const base64Files = await getBase64FromFiles(files);

                    this.props.onChange(files.map((file, index) => ({
                        file,
                        base64: base64Files[index]
                    })));
                } else {
                    this.props.onChange(files);
                }
            }

            if (!this.props.upload) {
                return;
            }

            uploadFiles(files, {
                project: this.props.projectId,
                task: this.props.taskId,
                doc: this.props.docId
            }).then(this.props.onUpload);
        } catch(e) {}
    }

    async checkLimit(files) {
        if (this.props.preventLimitCheck) {
            return Promise.resolve();
        }

        return checkStorageLimit(files.reduce((size, file) => file.size + size, 0));
    }

    showProcessingAlert(files) {
        if (!this.props.showProcessing) {
            return;
        }

        startFilesProcess(files);
    }

    hideProcessingAlert(files) {
        setTimeout(() => {
            endFilesProcess(files);
        }, 1000);
    }

    getSelectedFiles(event) {
        return Array.prototype.slice.call(this.fileElement.files, 0);
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            showDialog: () => {
                this.fileElement && this.fileElement.click();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }


    render() {
        return (
            <span className="file-upload" onClick={this.disabled ? this.showMaintenance : null}>
                {this.props.children}

                <input multiple={!this.props.single} style={this.disabled ? {display: 'none'} : null} type="file" ref={element => this.fileElement = element} onChange={this.handleChange} />
            </span>
        );
    }
}
